export default {
    loading: false,
    error: null,
    limits: [],
    consignmentCounts: [],
    routingDeadlines: [],
    loadingRoutingDeadlines: false,
    loadingRoutingDeadlinesError: false,
}
